(function (Rayban) {
  'use strict';

  var u = {

    debugCookieName: 'rbDebug',

    /** Extends an object passed as a first argument with the second one.
     *
     * @returns {object}
     */
    extend: function () {
      var self = this;
      for(var i=1; i<arguments.length; i++) {
        for(var key in arguments[i]) {
          if(arguments[i].hasOwnProperty(key)) {
            if (typeof arguments[0][key] === 'object'
                && typeof arguments[i][key] === 'object') {
              self.extend(arguments[0][key], arguments[i][key]);
            } else {
              arguments[0][key] = arguments[i][key];
            }
          }
        }
      }
      return arguments[0];
    },

    /** Interpolates strings and replaces placeolders with corresponding object properties.
     *
     * example:
     *   var str = "hello [username]!",
     *     o = {username: 'Foobar'};
     *   newval = interpolateString(str, o);
     *
     * expected result:
     * newval == 'hello Foobar'
     *
     * the string replacement is case insensitive
     * so, we will have the same results using:
     *   o = {username: 'Foobar'}
     * or
     *   o = {userName: 'Foobar'}
     *
     * @param {String} value
     * @param {object} o
     * @return {String}
     */
    interpolateString: function(value, o) {
      if (typeof value === 'string') {
        for (var prop in o) {
          if (o.hasOwnProperty(prop)) {
            value = value.replace(
              new RegExp('\\[' + prop + '\\]', 'ig'),
              o[prop]
            );
          }
        }
      }
      return value;
    },

    /** Retrieves a value of a specific parameter from the query string.
     *
     * @param {string} sParam - the name of the query strin parameter
     * @returns {string} - the value of the query string parameter.
     */
    getUrlParameter: function (sParam) {
      var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

      for (i = 0; i < sURLVariables.length; i += 1) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
          return sParameterName[1].replace(/\+/g, ' ');
        }
      }
      return undefined;
    },

    /** Removes a key from the query string parameter of URl 
     *  and replaces with new URL
     *  @param {string} key - Key param to be removed from the URL
     *  @param {string} sourceURL - Source URL from which param to be removed
     *  @return {string}
    */
    removeURLParam: function (key, sourceURL) {
      var resultURL = sourceURL.split("?")[0],
        param,
        paramsArray = [],
        queryString = sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
      if (queryString !== "") {
        paramsArray = queryString.split("&");
        for (var i = paramsArray.length - 1; i >= 0; i -= 1) {
          param = paramsArray[i].split("=")[0];
          if (param === key) {
            paramsArray.splice(i, 1);
          }
        }
        resultURL = paramsArray.length? (resultURL + "?" + paramsArray.join("&")) : resultURL;
      }
      return resultURL;
    },

    /** Used to show debug logs when rbDebug cookie is set to true.
     *
     *  Use "document.cookie = 'rbDebug=true; path=/;'"
     *  to set the cookie in the browser console.
     */
    debug: function (message) {
      if (this.readCookie(this.debugCookieName) === 'true') {
        console.debug(message);
      }
    },

    /** Creates a cookie
     *
     * @param {String} name
     * @param {String} value
     * @param {Integer} expirationDays
     */
    createCookie: function (name, value, expirationDays) {
      var expires = '';
      if (expirationDays) {
        var date = new Date();
        date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
      }
      document.cookie = name + '=' + value + expires + '; path=/';
    },

    /** Reads a cookie value
     *
     * @param {String} name
     * @return {String} the cookie value
     */
    readCookie: function (name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1,c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length,c.length);
        }
      }
      return null;
    },

    /** Deletes a cookie by given name.
     * @param {String} name
     */
    deleteCookie: function (name) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    },

    /**
     * Get the closest matching element up the DOM tree.
     * @private
     * @param  {Element} elem     Starting element
     * @param  {String}  selector Selector to match against
     * @return {Boolean|Element}  Returns null if not match found
     */
    getClosest: function ( elem, selector ) {

      // Element.matches() polyfill
      if (!Element.prototype.matches) {
          Element.prototype.matches =
              Element.prototype.matchesSelector ||
              Element.prototype.mozMatchesSelector ||
              Element.prototype.msMatchesSelector ||
              Element.prototype.oMatchesSelector ||
              Element.prototype.webkitMatchesSelector ||
              function(s) {
                  var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                      i = matches.length;
                  while (--i >= 0 && matches.item(i) !== this) {}
                  return i > -1;
              };
      }
      // Get closest match
      for ( ; elem && elem !== document; elem = elem.parentNode ) {
          if ( elem.matches( selector ) ) return elem;
      }
      return null;
    }

  };

  Rayban.utilities = u;
})(window.Rayban = window.Rayban || {});
